import { render } from "./DetailSaveEarth.vue?vue&type=template&id=43678430&scoped=true"
import script from "./DetailSaveEarth.vue?vue&type=script&lang=js"
export * from "./DetailSaveEarth.vue?vue&type=script&lang=js"

import "./DetailSaveEarth.vue?vue&type=style&index=0&id=43678430&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43678430"

export default script